import { HistoryOutlined, IdcardOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { ReactElement } from "react";
import { Link } from "react-router-dom";

const CustomerSidebar = ({ userId }): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu defaultSelectedKeys={["0"]} mode="inline">
            <Menu.Item
              key="details"
              className={pathname.includes("details") ? "active" : ""}
              icon={<IdcardOutlined />}
            >
              <Link to={`/users/${userId}/details`}>Basic Information</Link>
            </Menu.Item>

            <Menu.Item
              key="orders"
              icon={<HistoryOutlined />}
              className={pathname.includes("/orders") ? "active" : ""}
            >
              <Link to={`/users/${userId}/orders`}>Order History</Link>
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default CustomerSidebar;
